import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
} from "@fluentui/react-components";
import Button from "./Button";

type ConfirmationFormProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  dialogTitle: string;
  dialogContent: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
};

const ConfirmationForm: React.FC<ConfirmationFormProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  dialogTitle,
  dialogContent,
  confirmButtonLabel = "OK",
  cancelButtonLabel = "Cancel",
}) => {
  return (
    <Dialog open={isOpen}>
      <DialogSurface style={{ margin: "16px" }}>
        <DialogBody>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent>{dialogContent}</DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button label={confirmButtonLabel} onClick={onConfirm} />
            </DialogTrigger>
            {cancelButtonLabel && onCancel && (
            <DialogTrigger disableButtonEnhancement>
              <Button label={cancelButtonLabel} onClick={onCancel} />
            </DialogTrigger>
            )}
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ConfirmationForm;
